import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from 'react-modal';
import cn from 'classnames';
import isEmpty from 'lodash.isempty';

import Questionnaire from './Questionnaire';
import RelatedResponseRow from './RelatedResponseRow';
import './styles.scss';
import { Button } from '../../../components';

export default class ReplyModal extends Component {
	static propTypes = {
		isOpen: PropTypes.bool.isRequired,
		onCancel: PropTypes.func.isRequired,
		responseGroup: PropTypes.object,
		onSave: PropTypes.func.isRequired,
		responses: PropTypes.array,
		questions: PropTypes.array,
		relatedResponses: PropTypes.array
	}

	static defaultProps = {
		responses: [],
		questions: []
	}

	constructor(props) {
		super(props);
		this.state = {
			evisit_recommended: false,
			response: '',
			showQuestionnaire: true,
			showRelatedResponses: true,
		};
	}

	handleSave = () => {
		const { care_quest_response_groupId, vital_id } = this.props.responseGroup;
		if (care_quest_response_groupId) {
			this.props.onSave({
				id: care_quest_response_groupId,
				...this.state
			});
		} else {
			this.props.onSave({
				...this.state,
				vital_id,
				provider_response: this.state.response
			});
		}
	}

	handleChangeSuggestEvisit = () => {
		this.setState(prevState => ({
			evisit_recommended: !prevState.evisit_recommended
		}));
	}

	handleResponseChange = (event) => {
		this.setState({
			response: event.target.value
		});
	}

	componentDidUpdate(prevProps) {
		if (!prevProps.isOpen && this.props.isOpen) {
			this.setState({
				evisit_recommended: false,
				response: '',
				showQuestionnaire: true,
				showRelatedResponses: true
			});
		}
	}

	handleShowQuestionnaireToggle = (event) => {
		event.preventDefault();
		this.setState(currState => ({
			showQuestionnaire: !currState.showQuestionnaire
		}));
	}

	handleShowRelatedResponsesToggle = (event) => {
		event.preventDefault();
		this.setState(currState => ({
			showRelatedResponses: !currState.showRelatedResponses
		}));
	}

	render() {
		const { isOpen, onCancel, responseGroup, questions, responses, relatedResponses } = this.props;
		const { evisit_recommended, response, showQuestionnaire, showRelatedResponses } = this.state;

		let totalRelatedResponses = 0;
		if (relatedResponses && Array.isArray(relatedResponses)) {
			totalRelatedResponses = relatedResponses.length;
		}

		return (
			<Modal
				isOpen={isOpen}
				contentLabel="Reply"
				onRequestClose={onCancel}
				className={cn('modal-dialog', { 'reply-modal': responseGroup && !isEmpty(responseGroup.care_quest_group_name) })}
			>
				<div className="modal-content">
					<div className="modal-header">
						<button type="button" data-dismiss="modal" aria-label="Close" className="close" onClick={onCancel}>
							<em className="fa fa-times" />
						</button>
						<h4 className="modal-title">Reply to Patient (Single Response)</h4>
					</div>
					<div className="modal-body">
						<div className="pull-right form-group">
							<label className="control-label pr mt-sm">Suggest Visit</label>
							<label className="switch">
								<input
									type="checkbox"
									checked={evisit_recommended}
									onChange={this.handleChangeSuggestEvisit}
								/>
								<span />
							</label>
						</div>
						{responseGroup && (
							<h4>{responseGroup.name_first} {responseGroup.name_last}</h4>
						)}
						{responseGroup && !isEmpty(responseGroup.care_quest_group_name) && (
							<React.Fragment>
								<div className="form-group">
									<label>Care Plan Response</label>
									<textarea
										className="form-control"
										placeholder={`Please reply to the patient based on the ${responseGroup ? responseGroup.care_quest_group_name : null} Care Plan. Patient will receive a notification and email via Care Convene with your request.`}
										value={response}
										onChange={this.handleResponseChange}
									/>
								</div>
								<div className="row">
									<div className="col-md-6">
										<div className="panel panel-default">
											<div className={cn('panel-heading', { 'panel-heading-collapsed': showQuestionnaire })}>
												Questionnaire Response
												<a
													href="#"
													data-tool="panel-collapse"
													data-toggle="tooltip"
													title=""
													className="pull-right"
													data-original-title="Collapse Panel"
													onClick={this.handleShowQuestionnaireToggle}
												>
												<em className={cn('fa', { 'fa-plus': !showQuestionnaire, 'fa-minus': showQuestionnaire })}></em>
											</a>
											</div>
											<div className={cn('panel-wrapper', 'collapse', { 'in': showQuestionnaire })} aria-expanded={showQuestionnaire}>
												<div className="panel-body">
													<Questionnaire
														questions={questions}
														responses={responses}
													/>
												</div>
											</div>
										</div>
									</div>
									<div className="col-md-6">
										<div className="panel panel-default prior-responses">
											<div className={cn('panel-heading', { 'panel-heading-collapsed': showRelatedResponses })}>
												Prior Responses ({totalRelatedResponses})
												<a
													href="#"
													data-tool="panel-collapse"
													data-toggle="tooltip"
													title=""
													className="pull-right"
													data-original-title="Collapse Panel"
													onClick={this.handleShowRelatedResponsesToggle}
												>
												<em className={cn('fa', { 'fa-plus': !showRelatedResponses, 'fa-minus': showRelatedResponses })}></em>
											</a>
											</div>
											<div className={cn('panel-wrapper', 'collapse', { 'in': showRelatedResponses })} aria-expanded={showRelatedResponses}>
												<div className="table-responsive">
													<table className="table table-bordered">
													<thead>
														<tr>
															<th>Date of Response</th>
															<th>Care Plan Response</th>
															<th>Visit Recommended</th>
															<th>Linked Visit</th>
														</tr>
													</thead>
													<tbody>
														{relatedResponses && relatedResponses.map(relatedResponse => (
															<RelatedResponseRow
																key={relatedResponse.id}
																questions={questions}
																relatedResponse={relatedResponse}
															/>
														))}
													</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</React.Fragment>
						)}
						{responseGroup && !isEmpty(responseGroup.vital_name) && (
							<div className="form-group">
								<label>Vitals Result Response</label>
								<textarea
									className="form-control"
									placeholder="Please reply to the patient based on the results from the vitals tracking. Patient will receive a notification and email via Care Convene with your request."
									value={response}
									onChange={this.handleResponseChange}
								/>
							</div>
						)}
					</div>
					<div className="modal-footer">
						<Button
							large
							title="Cancel"
							onClick={onCancel}
						/>
						<Button
							className="ml"
							large
							primary
							onClick={this.handleSave}
							disabled={response.length < 1}
							title="Send"
						/>
					</div>
				</div>
			</Modal>
		);
	}
}
